"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LifecyclePage = void 0;
const React = __importStar(require("react"));
const LifecyclePageModelProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/lifecycle/LifecyclePageModelProvider");
const LifecyclePageDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/lifecycle/LifecyclePageDataProvider");
const LifecycleDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/lifecycle/LifecycleDataProvider");
const DataState_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/lifecycle/state/data/DataState");
const react_1 = require("react");
const LifecyclePage = () => {
    (0, react_1.useEffect)(() => {
        setTimeout(() => window.scrollTo({ top: 0 }), 0);
    }, []);
    return React.createElement(LifecycleDataProvider_1.LifecycleDataProvider, null,
        React.createElement(LifecyclePageModelProvider_1.LifecyclePageModelProvider, null,
            React.createElement(LifecyclePageDataProvider_1.LifecyclePageDataProvider, null,
                React.createElement(DataState_1.DataState, null))));
};
exports.LifecyclePage = LifecyclePage;
